module.exports = __webpack_public_path__ + "static/media/red_cloud_burst.5aff9d30.png";